export const MODE = {
  ZIPCODE: 'ZIPCODE',
  SEARCH: 'SEARCH',
  SELECTED: 'SELECTED',
};

export const LIST = {
  ROW_HEIGHT: 56,
  LIST_HEIGHT: 200,
};
